/* cl-cart-drawer (paragon): abre ao adicionar produto e no icone do carrinho; qty/remover via /cart/change.js;
   re-render pela Section Rendering API. Todo submit de /cart/add vira fetch nosso (inclusive com o
   Kaching, que mescla o kit no fetch); adicoes feitas pelos APPS (fetch/XHR de /cart/add) tambem
   abrem a gaveta quando terminam. */
(function(){
  if (window.__clCD) return; window.__clCD = true;
  var SID = 'cl-cart-drawer', HOLD_MS = 10 * 60000, KEY = 'cl-cd-hold', OWN = false;
  function root(){ return document.getElementById('cl-cart-drawer'); }
  function open(){ var r = root(); if(!r) return; r.classList.add('is-open'); r.setAttribute('aria-hidden','false'); document.body.classList.add('cl-cd-lock'); timer(); }
  function close(){ var r = root(); if(!r) return; r.classList.remove('is-open'); r.setAttribute('aria-hidden','true'); document.body.classList.remove('cl-cd-lock'); }
  function bubble(n){
    document.querySelectorAll('#cart-icon-bubble').forEach(function(a){
      var b = a.querySelector('.cart-count-bubble');
      if (n > 0){ if(!b){ b = document.createElement('div'); b.className = 'cart-count-bubble'; a.appendChild(b); } b.innerHTML = '<span aria-hidden="true">' + n + '</span>'; }
      else if (b) b.remove();
    });
  }
  function timer(){}
  function swap(html){
    if (!html) return;
    var r = root(); var wasOpen = r && r.classList.contains('is-open');
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('#cl-cart-drawer'); if(!fresh || !r) return;
    if (wasOpen) { fresh.classList.add('is-open'); fresh.setAttribute('aria-hidden','false'); }
    r.replaceWith(fresh);
    bubble(parseInt(fresh.getAttribute('data-count') || '0', 10));
    timer();
  }
  function refresh(){
    return fetch('/?sections=' + SID, {credentials:'same-origin'}).then(function(r){ return r.json(); })
      .then(function(j){ swap(j[SID]); }).catch(function(){});
  }
  function busy(on){ var r = root(); if(r) r.classList.toggle('is-loading', !!on); }
  function change(key, qty){
    busy(true); OWN = true;
    return fetch('/cart/change.js', {method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key, quantity:qty, sections:SID})})
      .then(function(r){ return r.json(); })
      .then(function(j){ OWN = false; busy(false); if (j.sections && j.sections[SID]) swap(j.sections[SID]); else refresh(); })
      .catch(function(){ OWN = false; busy(false); refresh(); });
  }
  function add(body){
    OWN = true;
    return fetch('/cart/add.js', {method:'POST', credentials:'same-origin', headers:{'Accept':'application/json'}, body:body})
      .then(function(r){ OWN = false; if(!r.ok) throw r; return r.json(); })
      .then(function(){ return refresh(); }).then(open)
      .catch(function(e){ OWN = false; throw e; });
  }

  /* adicoes feitas por APPS (Kaching etc.): abre a gaveta quando /cart/add termina */
  var of = window.fetch;
  if (of) window.fetch = function(input, init){
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = of.apply(this, arguments);
    var mine = init && init.headers && (init.headers['X-Cl-Own'] || (init.headers.get && init.headers.get('X-Cl-Own')));
    if (!OWN && !mine && /\/cart\/add(\.js|\?|$)/.test(url)) p.then(function(r){ if (r.ok) setTimeout(function(){ refresh().then(open); }, 50); }).catch(function(){});
    return p;
  };
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m, url){
    if (/\/cart\/add(\.js|\?|$)/.test(url || '')) this.addEventListener('load', function(){ if (this.status < 400) refresh().then(open); });
    return xo.apply(this, arguments);
  };

  document.addEventListener('click', function(e){
    var t = e.target; if(!t || !t.closest) return;
    if (t.closest('[data-cl-cd-close]')) { e.preventDefault(); close(); return; }
    var q = t.closest('[data-cl-qty]');
    if (q && root() && root().contains(q)) { e.preventDefault(); change(q.getAttribute('data-key'), Math.max(0, parseInt(q.getAttribute('data-cl-qty'), 10))); return; }
    var a = t.closest('[data-cl-add]');
    if (a) { e.preventDefault(); a.disabled = true; var fd = new FormData(); fd.append('id', a.getAttribute('data-cl-add')); fd.append('quantity', '1'); add(fd).catch(function(){ a.disabled = false; }); return; }
    var opener = t.closest('#cart-icon-bubble, a[href="/cart"], [data-cl-cart-open]');
    if (opener && !(root() && root().contains(opener))) { e.preventDefault(); e.stopPropagation(); open(); refresh(); }
  }, true);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
  document.addEventListener('submit', function(ev){
    var form = ev.target; if (!(form instanceof HTMLFormElement)) return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    /* Com o Kaching tambem assumimos o submit (retrabalho 2026-09-30: "o botao leva para /cart"):
       o listener de submit do app (document, fase de bubble) faz o fetch e depois forca
       location.href = '/cart'. Aqui (capture) rodamos antes, o evento para, e o nosso
       fetch('/cart/add.js') passa pelo interceptador de fetch/XHR do app, que mescla os itens
       do kit (properties[__kaching_bundles]); no modo sem interceptador ele ja adicionou os
       extras e pos a quantidade no form. Resultado: gaveta, nao /cart. */
    ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"],[name="add"]'); if (btn) btn.setAttribute('aria-disabled', 'true');
    add(new FormData(form)).catch(function(){ form.submit(); }).then(function(){ if (btn) btn.removeAttribute('aria-disabled'); });
  }, true);

  /* codigo de influenciador / desconto: /discount/CODIGO grava o cupom na sessao (vale no checkout) */
  document.addEventListener('submit', function(ev){
    var f = ev.target; if (!(f instanceof HTMLFormElement) || !f.hasAttribute('data-cl-cd-code')) return;
    ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
    var inp = f.querySelector('input[name="code"]'), msg = f.querySelector('[data-cl-cd-msg]');
    var code = (inp && inp.value || '').trim(); if (!code) return;
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {credentials:'same-origin'})
      .then(function(){ if (msg) { msg.hidden = false; msg.textContent = 'Code "' + code + '" will be applied at checkout.'; } })
      .catch(function(){ if (msg) { msg.hidden = false; msg.textContent = 'Could not apply this code.'; } });
  }, true);
  window.clCartDrawer = {open:open, close:close, refresh:refresh};
})();
